import React from 'react';

const DiscordIcon = () => {
  const handleClick = () => {
    window.open('https://discord.gg/SbSCD7NXSY', '_blank');
  };

  return (
    <div
      style={{
        position: 'fixed',
        bottom: '20px',
        right: '20px',
        cursor: 'pointer',
        borderRadius: '50%',
        overflow: 'hidden',
        ...(window.innerWidth <= 767 && { bottom: '8px'}),
      }}
      onClick={handleClick}
    >
      <img
        src={`${process.env.PUBLIC_URL}/assets/icon/discord.png`}
        alt="Discord"
        style={{
          width: '45px',
          height: '45px',
          display: 'block',
          ...(window.innerWidth <= 767 && { width: '38px', height: '38px' }),
        }}
      />
    </div>
  );
};

export default DiscordIcon;
